<template>
    <div class="wrap">

        <!-- 成员页面 -->
        <div class="clerkWrap" v-show="!ticket_page">
            <div class="header">
                <div class="top">
                    <div class="bu-name overhide" :title="`${buInfo.bu_name}（${buInfo.user_count}人）`">{{ `${buInfo.bu_name}（${buInfo.user_count}人）` }}</div>
                    <div class="bu-leader">合伙人：{{ buInfo.bu_manager_name }}</div>
                    <div class="time">BU创建时间：{{ buInfo.created_at | justDate }}</div>
                </div>
                <div class="other">

                    <div class="text">
                        <div class="overhide" :title="buInfo.bu_description || '暂无描述'">BU描述：{{ buInfo.bu_description || "暂无描述" }}</div>
                        <div>经营范围：{{ describe_str || "暂无" }}</div>
                    </div>
                    <div class='func'>
                        <div class="front-btn green" @click.stop.prevent="pop.changeFlag = true">调岗</div>
                        <div class="front-btn green" @click.stop.prevent="pop.addFlag = true">增岗</div>
                        <div class="front-btn red" @click.stop.prevent="()=>{getTicketList();ticket_page = true}">罚单</div>
                        <span class="newInfo">
                            <span class="point">&nbsp;</span>红点表示职员在当天收到过罚单
                        </span>
                    </div>
                </div>

                <!-- <span class="showList">
                    <i :class="{selected:isBlock}" @click="isBlock=!isBlock" ></i>
                    <s :class="{selected:!isBlock}" @click="isBlock=!isBlock"></s>
                </span> -->
            </div>

            <z-scrollDiv class="block">
                <!-- 盒子 -->
                <div class="block-item">
                    <personbox @click="openUserPop" v-for="item in bu_users" :key="item.id" :info="item"></personbox>
                </div>
                <!-- 列表 -->
                <!-- <div class="person-list" v-show="!isBlock">
                    <div class="person-head">
                            <div>头像</div>
                            <div>姓名</div>
                            <div>角色</div>
                            <div>工号</div>
                            <div>岗位</div>
                            <div>职级</div>
                            <div>工作年限</div>
                            <div>出生日期</div>
                            <div>入职时间</div>
                    </div>
                    <z-scrollDiv class="person-main">
                        <div class="person-item" @click="openUserPop" v-for="item in bu_users" :item="item.id" :key="item.id">
                            <div>
                                <img class="avatar" :src="item.user_logo" alt="">
                            </div>
                            <div>{{ item.real_name }}</div>
                            <div>{{ item.bu_identity_type==1? "bu合伙人":"职员" }}</div>
                            <div>{{ item.user_name }}</div>
                            <div>{{ item.position_name }}</div>
                            <div>{{ item.staffing_grade }}级</div>
                            <div>{{ item.work_date | workAge }}</div>
                            <div>{{ item.birth_date | justDate }}</div>
                            <div>{{ item.work_date | justDate }}</div>
                        </div>
                    </z-scrollDiv>
                </div> -->
            </z-scrollDiv>
        </div>

        <!-- 罚单页面 -->
        <div class="ticket-detail" v-show="ticket_page">
            <div class="head">
                <div class="func">
                    <span>罚单类型：</span>
                    <el-select class="top-choose" v-model="ticket_search_type" clearable placeholder="请选择">
                        <el-option v-for="item in personalTicket" :key="item.id" :label="item.ticket_name" :value="item.id">
                        </el-option>
                    </el-select>
                    <span style="margin-left:20px;">罚单日期</span>
                    <el-date-picker class="top-choose" v-model="datePick_start" type="date" placeholder="选择日期" :picker-options="picker_special">
                    </el-date-picker>
                    <span>~</span>
                    <el-date-picker class="top-choose" v-model="datePick_end" type="date" placeholder="选择日期" :picker-options="picker_special">
                    </el-date-picker>
                    <div style="margin-left:20px;"  class='front-btn green' @click="search()">查询</div>
                    <div class="front-btn red" @click="pop.ticketFlag = true">开罚单</div>
    
                </div>
                <i @click="ticketListClose" class="el-icon-close"></i>
            </div>
            <div class="list">
                <div class="list-head">
                    <div>罚单日期
                        <div class="angle-wrap">
                            <i class="el-icon-caret-top" :class="{active:sort[0]}" @click="sortList(0)"></i>
                            <i class="el-icon-caret-bottom" :class="{active:sort[1]}" @click="sortList(1)"></i>
                        </div>
                    </div>
                    <div>罚单编号</div>
                    <div>罚单对象</div>
                    <div>罚单类型</div>
                    <div>快币金额(币/人)</div>
                    <div>罚单原因</div>
                </div>
                <z-scrollDiv class="list-detail">
                    <div class="item" v-for="item in ticket_list" :key="item.id">
                        <div>{{ item.created_at | justDate }}</div>
                        <div>{{ item.code }}</div>
                        <div style="font-size:0;">
                            <div class="text-hide">{{ item.real_name }}</div>
                            <div class="more">{{ item.real_name }}</div>
                        </div>
                        <div>{{ item.ticket_name }}</div>
                        <div>{{ item.ticket_amount }}</div>
                        <div class="overhide" :title="item.remark">{{ item.remark }}</div>
                    </div>
                    <z-noData :list="ticket_list"></z-noData>
                </z-scrollDiv>
            </div>
            <z-pagination class="inside" @getPage="search" :data='ticket_data'></z-pagination>
        </div>
    

        <!--******弹窗在这里*******  -->
    
        <!--调岗申请-->
        <el-dialog v-form:changePost @open="openFocus('area_change')" @close="changeClose()" title="调岗申请" :visible.sync="pop.changeFlag">
            <div class="form-item">
                <div class="item-title must">调岗类型：</div>
                <div class="item-text">
                    <el-select v-tar="pop.changeType" rule="noVal" v-model="pop.changeType" placeholder="请选择">
                        <el-option v-for="item in pop.changeOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="form-item">
                <div class="item-title must">调岗人员：</div>
                <div class="item-text">
                    <el-select v-tar="pop.changeIds.join(',')" rule="noVal" v-model="pop.changeIds" multiple filterable allow-create placeholder="请选择调岗人员" style="width: 452px;">
                        <el-option v-for="item in changeUsers" :key="item.id" :label="item.real_name" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="form-item">
                <div class="item-title must">申请理由：</div>
                <div class="item-wrap">
                    <textarea v-tar="pop.changeReason" rule="reason" v-arg="['申请理由']" v-model="pop.changeReason" ref="area_change"></textarea>
                </div>
            </div>
    
            <div slot="footer" class="dialog-footer">
                <el-button @click="pop.changeFlag = false">取 消</el-button>
                <el-button type="primary" @click="confirm_change">提交申请</el-button>
            </div>
        </el-dialog>
    
        <!--增岗申请-->
        <el-dialog v-form:addPost @close="addClose()" title="增岗申请" :visible.sync="pop.addFlag">
            <div class="form-item">
                <div class="item-title must">岗位名称：</div>
                <div class="item-text">
                    <el-select v-tar="pop.addNameId" rule="noVal" v-model="pop.addNameId" z-noData-text="暂无职位，需自行添加" placeholder="请选择">
                        <z-limitOption v-for="item in addPosts" :key="item.id" :label="item.positionName" :value="item.id">
                            <!-- <span style="float: left">{{ item.label }}</span>
                            <span @click.stop="delAddOption(item.value)" style="float: right;" class="el-icon-delete"></span> -->
                        </z-limitOption>
                    </el-select>
                    <el-button class="add-post" icon="plus" @click="openEdit()"></el-button>
                    <!--添加职位-->
                    <transition name="fade">
                        <div class="add-input" v-show="pop.add_inputFlag" @mouseover="pop.add_hover = true" @mouseleave="pop.add_hover = false">
                            <input v-model="pop.add_editText" @keyup.enter="uploadEdit()" @blur="hideEdit()" ref="post_input" placeholder="请输入岗位名称">
                            <div class="btns">
                                <i @click="clearEdit()" class="el-icon-close"></i>
                                <i @click="uploadEdit()" v-show="!pop.add_up_ing" ref="add_check" class="el-icon-check"></i>
                                <i v-show="pop.add_up_ing" class="el-icon-loading"></i>
                            </div>
                        </div>
                    </transition>
    
                </div>
            </div>
            <div class="form-item">
                <div class="item-title must">增岗类型：</div>
                <div class="item-text">
                    <el-select v-tar="pop.addType" rule="noVal" v-model="pop.addType" placeholder="请选择">
                        <el-option v-for="item in pop.addOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="form-item">
                <div class="item-title must">增岗人数：</div>
                <div class="item-text">
                    <el-input v-tar="pop.addNum" rule="noVal integer" v-model="pop.addNum" placeholder="请输入数字"></el-input>
                </div>
            </div>
            <div class="form-item">
                <div class="item-title must">岗位需求：</div>
                <div class="item-wrap">
                    <textarea v-tar="pop.addRequire" rule="reason" v-arg="['岗位需求']" v-model="pop.addRequire" placeholder="请输入岗位需求"></textarea>
                </div>
            </div>
            <div class="form-item">
                <div class="item-title must">申请理由：</div>
                <div class="item-wrap">
                    <textarea v-tar="pop.addReason" rule="reason" v-arg="['申请理由']" v-model="pop.addReason" placeholder="请输入申请理由"></textarea>
                </div>
            </div>
    
            <div slot="footer" class="dialog-footer">
                <el-button @click="pop.addFlag = false">取 消</el-button>
                <el-button type="primary" @click="confirm_add">提交申请</el-button>
            </div>
        </el-dialog>
    
        <!--开罚单  -->
        <el-dialog v-form:ticket @close="ticketClose()" title="职员罚单" :visible.sync="pop.ticketFlag">
            <div class="form-item">
                <div class="item-title must">处罚对象：</div>
                <div class="item-text">
                    <el-select v-tar="pop.ticketIds" rule="noVal" v-model="pop.ticketIds" multiple filterable allow-create placeholder="请选择" style="width: 452px;">
                        <el-option v-for="item in changeUsers" :key="item.id" :label="item.real_name" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="form-item">
                <div class="item-title must">罚单类型：</div>
                <div class="item-text">
                    <el-select v-tar="pop.ticketType" rule="noVal" v-model="pop.ticketType" placeholder="请选择">
                        <el-option v-for="item in worker_ticket" :key="item.id" :label="item.ticket_name" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <!-- <div class="form-item">
                <div class="item-title must">罚单金额：</div>
                <div class="item-text">
                    <el-input v-tar="pop.ticketAmount" rule="noVal number" v-model="pop.ticketAmount" placeholder="请输入数字">
                        <template slot="append">币/人</template>
                    </el-input>
                </div>
            </div> -->
            <div class="form-item">
                <div class="item-title must">处罚原因：</div>
                <div class="item-wrap">
                    <textarea v-tar="pop.ticketReason" rule="reason" v-arg="['处罚原因']" v-model="pop.ticketReason" placeholder="请输入处罚原因"></textarea>
                </div>
            </div>
    
            <div slot="footer" class="dialog-footer">
                <el-button @click="pop.ticketFlag = false">取 消</el-button>
                <el-button type="primary"  @click="confirm_ticket">确认</el-button>
            </div>
        </el-dialog>
    
        <!--职员数据  -->
        <el-dialog class="user-window" @open="getUserData()" @close="userClear()" title="职员数据" :size="'large'" :visible.sync="user.userFlag">
            <div class="user-tab-head">
                <div class="title" :class="{active:user.userActiveIndex==0}" @click="user.userActiveIndex = 0">结算明细</div>
                <div class="title" :class="{active:user.userActiveIndex==1}" @click="user.userActiveIndex = 1">罚单明细</div>
                <div class="title" :class="{active:user.userActiveIndex==2}" @click="user.userActiveIndex = 2">职级明细</div>
                <!--结算明细  -->
                <div class="func" v-show="user.userActiveIndex==0">
                    <span>年度：</span>
                    <el-select class="top-choose" v-model="user.bonusYear" clearable placeholder="请选择">
                        <el-option v-for="item in bonusYearOptions" :key="item"  :value="item">
                        </el-option>
                    </el-select>
                    <span>周期：</span>
                    <el-select class="top-choose" v-model="user.bonusCycleId" clearable placeholder="请选择" z-noData-text="请先选择年份">
                        <el-option v-for="item in bonusCycleOptions" :key="item.id" :label="item.cycle_number_show" :value="item.id">
                        </el-option>
                    </el-select>
                    <div class='front-btn green shift' @click="bonusSearch()">查询</div>
                </div>

                <!--罚单明细  -->
                <div class="func" v-show="user.userActiveIndex==1">
                    <!-- <span>年度：</span>
                    <el-select class="top-choose" v-model="user.ticketYear" clearable placeholder="请选择">
                        <el-option v-for="item in bonusYearOptions" :key="item"  :value="item">
                        </el-option>
                    </el-select>
                    <span>周期：</span>
                    <el-select class="top-choose" v-model="user.ticketCycleId" clearable placeholder="请选择" z-noData-text="请先选择年份">
                        <el-option v-for="item in ticketCycleOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select> -->
                    <el-date-picker class="top-choose" v-model="user.datePick_start" type="date"  placeholder="选择日期" :picker-options="picker_special">
					</el-date-picker>
					<small>~</small>
					<el-date-picker class="top-choose" v-model="user.datePick_end" type="date" placeholder="选择日期" :picker-options="picker_special">
					</el-date-picker>
                    <span style="margin-left:10px">罚单类型：</span>
					<el-select class="top-choose" v-model="user.typeId" clearable placeholder="请选择">
						<el-option v-for="item in personalTicket" :key="item.id" :value="item.id" :label="item.ticket_name">
						</el-option>
					</el-select>
                    <div class='front-btn green shift' @click="userTicketSearch()">查询</div>
                </div>

                <!--职级明细  -->
                <div class="func" v-show="user.userActiveIndex==2">
                    <el-date-picker class="top-choose" v-model="user.pmt_datePick_start" type="date" placeholder="选择日期" :picker-options="picker_special">
					</el-date-picker>
					<small>~</small>
					<el-date-picker class="top-choose" v-model="user.pmt_datePick_end" type="date" placeholder="选择日期" :picker-options="picker_special">
					</el-date-picker>
                    <div class='front-btn green shift' @click="searchUserPmt()">查询</div>
                </div>
            </div>
            <div class="user-tab-wrap">
                <!--结算明细  -->
                <div v-show="user.userActiveIndex==0">
                    <div class="user-list settle">
                        <div class="head">
                            <div>奖金周期</div>
                            <div>周期跨度</div>
                            <div>结算单生成日期</div>
                            <div>结算单确认日期</div>
                            <div>是否已确认</div>
                            <div>详情</div>
                        </div>
                        <z-scrollDiv class="user-wrap">
                            <div class="item" v-for="item in user.bonusData.list" :key="item.id">
                                <div>{{ `${item.cycle_year}年#${item.cycle_number}`}}</div>
                                <div>{{ item.cycle_start | justDate }}至{{ item.cycle_end | justDate }}</div>
                                <div>{{ item.created_at }}</div>
                                <div>{{ item.confirm_time?item.confirm_time:"-- --" }}</div>
                                <div>{{ item.confirm_time?"是":"否" }}</div>
                                <div @click="showBill(item)">详情</div>
                            </div>
                            <z-noData :list="user.bonusData.list"></z-noData>
                        </z-scrollDiv>
                    </div>
                    
                    <z-pagination  class="inside" @getPage="bonusSearch" :data='user.bonusData'></z-pagination>
                </div>

                <!--罚单明细  -->
                <div v-show="user.userActiveIndex==1">
                    <div class="user-list ticket">
                        <div class="head">
                            <div>罚单编号</div>
                            <div>罚单日期</div>
                            <div>罚单类型</div>
                            <div>罚币金额(币)</div>
                            <div>处罚原因</div>
                        </div>
                        <z-scrollDiv class="user-wrap">
                            <div class="item" v-for="item in user.ticketData.list" :key="item.id">
                                <div>{{ item.code }}</div>
                                <div>{{ item.created_at }}</div>
                                <div>{{ item.ticket_name }}</div>
                                <div>{{ item.ticket_amount }}</div>
                                <div class="overhide" :title="item.remark">{{ item.remark }}</div>
                            </div>
                            <z-noData :list="user.ticketData.list"></z-noData>
                        </z-scrollDiv>
                    </div>
                    
                    <z-pagination  class="inside" @getPage="userTicketSearch" :data='user.ticketData'></z-pagination>
                </div>

                <!--职级明细  -->
                <div v-show="user.userActiveIndex==2">
                    <div class="user-list pmt">
                        <div class="head">
                            <div>操作日期</div>
                            <div>职级变化</div>
                            <div>当前职级</div>
                            <div>备注</div>
                        </div>
                        <z-scrollDiv class="user-wrap">
                            <div class="item" v-for="item in user.pmtData.list" :key="item.id">
                                <div>{{ item.created_at }}</div>
                                <div>{{ (item.bill_type==1?"+":"-") + item.amount }}</div>
                                <div>{{ item.balance }}</div>
                                <div class="overhide" :title="item.remark">{{ item.remark }}</div>
                            </div>
                            <z-noData :list="user.pmtData.list"></z-noData>
                        </z-scrollDiv>
                    </div>
                    
                    <z-pagination  class="inside" @getPage="searchUserPmt" :data='user.pmtData'></z-pagination>
                </div>
            </div>
        </el-dialog>

        <!-- 账单详情 -->
		<el-dialog  class="z-bill" title="结算账单" :size="'large'"  :visible.sync="billFlag">
			<div class="bill-table">
				<div class="head">
					<div>奖金周期</div>
					<div>快币类型</div>
					<div>数量</div>
					<div>当期汇率</div>
					<div>金额</div>
					<!-- <div>详情</div> -->
				</div>
				<div class="item" v-for="(item,index) in bill.list" :key="item.id">
					<div>{{ index==0?bill_cycle:"" }}</div>
					<div>{{ item.currency_name }}</div>
					<div>{{ item.trans_amount+'币' }}</div>
					<div>{{ item.currency_rate }}</div>
					<div>{{ item.trans_number+"元" }}</div>
					<!-- <div>{{ item.remark }}</div> -->
				</div>
                <div class="item item-total" v-show='bill.periodCurrPersonalSummary && bill.periodCurrPersonalSummary.confirm_money < 0'>
                    <div>上期结余</div>
                    <div>{{ bill.periodCurrPersonalSummary | bonus }}</div>
                </div>
                <div class="item item-total">
                    <div>合计</div>
                    <div>{{ bill.currPersonalSummary | bonus }}</div>
                </div>
				<!-- <div class="item deviate" v-for="item in lastData" :key="item.id">
					<div>上期结余</div>
					<div>{{ item.total+"元" }}</div>
				</div>
				<div class="item deviate">
					<div>合计</div>
					<div>{{ total+"元" }}</div>
				</div> -->

			</div>
		</el-dialog>
    
    </div>
</template>

<script type="text/ecmascript-6">
import personbox from "./personBox.vue"
import { mapState,mapGetters } from "vuex"
import { getBonusCycleOptions } from "src/control/common.js"


export default {
    components: {
        personbox,
    },

    data() {
        return {
            addPosts:[],   //增岗 岗位list

            ticket_page: false,   //罚单详情判断器
            ticket_search_type: "", //罚单搜索 罚单类型
            ticket_data: {},   //罚单条目
            datePick_start: "",  //bu罚单数据开始日期
            datePick_end: "",   //bu罚单数据结束日期
            
            sort: [0, 1],
            // 一堆弹窗判断器
            pop: {
                changeFlag: false,  //调岗  弹窗
                changeReason: "",   //调岗  理由
                changeType: "",      //调岗  类型
                changeOptions: [{   //调岗  类型选项
                    value: '1',
                    label: '内部转岗'
                }],
                changeIds: [],      //调岗  人员id

                addFlag: false,  //增岗  弹窗
                addNameId: "",      //增岗  名称
                addType: "",      //增岗  类型
                addNum: "",       //增岗  人数
                addRequire: "",   //增岗  需求
                addReason: "",   //增岗  理由
                addOptions: [{   //增岗  类型选项
                    value: '1',
                    label: '内部转岗'
                }, {
                    value: '2',
                    label: '社会招聘'
                }],
                add_inputFlag: false,  //增岗 输入框
                add_hover: false,      //增岗 悬浮判断器
                add_editText: "",    //增岗 内容
                add_up_ing: false,   //上传新建职位判断器
                // add_loading: false,   //申请提交判断器

                ticketFlag: false,  //开罚单  弹窗
                ticketIds: [],      //开罚单  人员id
                ticketType: "",      //开罚单  类型
                ticketAmount: "",       //开罚单  金额
                ticketReason: "",   //开罚单  理由
                // ticket_loading: false,  //开罚单 申请判断器
            },

            // 职员大弹窗
            user:{
                userFlag: false,  //职员数据 弹窗
                userActiveIndex: 0,  //职员数据  默认tab
                id:"",   //用户id
                bonusData:{},  //奖金周期的数据
                bonusYear:"",   //奖金查询年份
                bonusCycleId:"",  //奖金查询周期
                cycle_list:[],   //周期的数据
                bonusCycleOptions:[], // 奖金周期选项
                

                ticketData:{}, //个人的罚单数据
                datePick_start:"", // 罚单查询起始时间
                datePick_end:"",  //罚单查询终止时间
                typeId:"",   //罚单查询 罚单类型
                // ticketYear:"", // 罚单查询年份
                // ticketCycleId:"",  //罚单查询周期

                pmtData:{},  //个人职级数据
                pmt_datePick_start:"",  //职级查询 起始时间
                pmt_datePick_end:"",  //职级查询 终止时间

            },

            // 结算账单
            billFlag:false,  //弹窗
            bill:{},  //账单数据
            bill_cycle:"", //奖金周期
            total:0,   //结算的合计

        }
    },

    computed: {
        ...mapState(["picker_special",'buInfo',"bu_users"]),
        ...mapState({
            personalTicket:state => state.personalTicket.filter(item=>{
                // item.ticket_target == 30 &&
                return  item.ticket_switch == 1;
            }),
            worker_ticket:state => state.personalTicket.filter(item=>{
                return  item.ticket_target == 30 && item.ticket_switch == 1;
            }),
        }),
        ...mapGetters(["bonusYearOptions",'taskTplObj']),
        describe_str(){  //bu信息--经营范围描述文本
            let str = this.buInfo.sub_template_ids;
            return  str && str.split(",").map(id=>{
                return this.taskTplObj[id] && this.taskTplObj[id].tpl_name;
            }).join("、");
        },

        // *****罚单数据 账单数据
        ticket_list() {  //罚单列表数据
            return this.ticket_data.list;
        },
        sortKey() {  //排序关键字段
            return this.sort[0] ? "asc" : "desc";
        }, 

        /****职员数据********************/
        bonusCycleOptions(){  //搜索选项 年份对应的周期列表
            return getBonusCycleOptions(this.user.bonusYear);
        },

        /***表单列表**************/
        //调岗人员
        changeUsers() {
            return this.bu_users.filter(user=>{
                return user.bu_identity_type != 1 && user.isTransferred == 0;   //isTransferred = 0  表示可以被调岗
            });
        },
    },

    watch: {
        "user.bonusYear"(val){  //联动
            this.user.bonusCycleId = "";
        },
    },

    created() {
        // bu-信息
        this.$func.getUserBu(true);  //拿BU信息
        this.$func.getTaskTpl();  //拿任務類型

        //bu 职员和罚单信息
        this.$func.getPersonalTicket(true);  //拿个人罚单类型列表
        this.$func.getBuMembers(true);  //拿成员list 
        this.$func.getPost(true,(data)=>{ //拿公司岗位
            this.addPosts = data;
        });  
    },

    methods: {
        //*****罚单详情*************/ 

        getTicketList(obj) {   //获取罚单数据
            let url = "api/manager/ticket_detail/users";
            let config = obj ? { params: obj } : {};

            this.$http.get(url, config).then(res => {
                if(res.status == 200){
                    this.ticket_data = res.res_data || {};
                }
            });
        },
        search(page) {  //罚单查询
            let obj = {
                ticket_category_id: this.ticket_search_type,
                start_date: this.datePick_start,
                end_date: this.datePick_end,
                "ticket_detail.created_at": this.sortKey,
                page: page
            };
            this.getTicketList(obj);
        },
        ticketListClose(){
            this.ticket_page = false;
            this.datePick_start = "";
            this.datePick_end = "";
            this.ticket_search_type = "";
        },
        // makeUser(arr) {  //根据参数拼接用户字符串
        //     return arr.reduce((str, obj, index) => {
        //         let name = getUser(obj.user_id).real_name;
        //         if (index == 0) {
        //             return name;
        //         }
        //         return str + "、" + name;
        //     }, "");
        // },
        // makeTicketType(id) {   //根据id  获取罚单类型
        //     let res = "";
        //     this.personTicket.some(option => {
        //         return option.id == id && (res = option.ticket_name);
        //     });
        //     return res;
        // },

        sortList(index) {  //升降序
            this.sort = [0, 0];
            this.sort.splice(index, 1, true);

            this.search();
        },

        //****职员数据大弹窗**************************/ 
        openUserPop(id){    //点击弹窗
            this.user.userActiveIndex = 0;
            this.user.id = id;
            this.user.userFlag = true;
            console.log(`id：${id}`)
        },
        getUserData(){   //职员表单拉数据
            this.getBonusData();
            this.getUserTicketData();
            this.getUserPmtData();

            this.$func.getBonusCycle(true);  // 获取奖金周期列表
        },
        userClear(){  //职员数据  关闭清除
            this.user.bonusYear = "";
            this.user.bonusCycleId = "";
            // this.user.ticketYear = "";
            // this.user.ticketCycleId = "";
            this.user.datePick_start = "";
            this.user.datePick_end = "";
            this.user.typeId = "";

            this.user.pmt_datePick_start = "";
            this.user.pmt_datePick_end = "";
        },


        getBonusData(obj = {}){  //拉取职员奖金数据
            let userId = this.user.id;
            let url = "api/clerk/curr_personal_summary_detail/"+userId;

            this.$http.get(url,obj).then(res=>{
                if(res.status == 200){
                    this.user.bonusData = res.res_data;
                }
            });
        },
        bonusSearch(page){ //查询奖金数据
            let obj = {
                year:this.user.bonusYear,
                cycle_detail_id:this.user.bonusCycleId,
                page:page,
            }
            this.getBonusData({params:obj});
        },

        getUserTicketData(obj){ //拉取职员罚单数据
            let userId = this.user.id;
            let url = `api/clerk/ticket_detail/${userId}`;
            let config = obj ? { params: obj } : {};

            this.$http.get(url, config).then(res => {
                if(res.status == 200){
                    this.user.ticketData = res.res_data;
                }
            });
        },
        userTicketSearch(page){  //查询职员罚单数据
            let obj = {
                // cycle_year:this.user.ticketYear,
                // cycle_detail_id:this.user.ticketCycleId,
                start_date:this.user.datePick_start,
                end_date:this.user.datePick_end,
                ticket_category_id:this.user.typeId,
                page:page,
            };
            this.getUserTicketData(obj);
        },

        getUserPmtData(obj){  //拉取职员默认职级数据
            let userId = this.user.id;
            let url = `api/clerk/pmt_personal_detail/${userId}`;
            let config = obj ? { params: obj } : {};

            this.$http.get(url, config).then(res => {
                if(res.status == 200){
                    this.user.pmtData = res.res_data;
                }
            });
        },
        searchUserPmt(page){   //查询职员职级数据
            let obj = {
                page:page,
                start_date:this.user.pmt_datePick_start,
                end_date:this.user.pmt_datePick_end,
            }

            this.getUserPmtData(obj);
        },

        showBill(item) {  //展示结算账单
            let cycleId = item.cycle_detail_id;
            this.bill_cycle = `${item.cycle_year}年#${item.cycle_number}`;
			let url = `api/clerk/curr_personal_detail/${item.id}`;
			this.$http.get(url,{
                params:{
                    cycle_detail_id:cycleId,
                    // user_id: this.user.id,
                }
            }).then(res => {
                if(res.status == 200){
                    this.bill = res.res_data;
                    this.billFlag = true;
                }
			}).catch();
		},

        //*****弹窗*******************/
        openFocus(str) {  //弹窗后，表单获得焦点
            setTimeout(() => {
                this.$refs[str].focus();
            }, 0);
        },


        // *****调岗****************
        changeClose() {  //数据清空
            this.pop.changeReason = '';
            this.pop.changeIds = [];
            this.pop.changeType = "";
            this.$form.clear("changePost");
        },
        confirm_change() {  //确定调岗
            let res = this.$form.check("changePost");
            if (!res) {
                return;
            }

            let reason = this.pop.changeReason;
            let ids = this.pop.changeIds;
            let type = this.pop.changeType;
            
            this.$func.loading(true);
            this.$http.post("api/manager/transfer_position_req", {
                req_type: type,
                sub_user_ids: ids.join(","),
                remark: reason,
            }).then((res) => {
                if(res.status == 200){
                    this.successTip("调岗申请已提交成功");
                    this.pop.changeFlag = false;
                }
                this.$func.loading(false);
            }).catch(error => {
                this.errorTip("申请提交失败");
                this.$func.loading(false);
            });

        },


        // *****增岗***********************
        openEdit() {  //打开编辑框
            this.pop.add_inputFlag = true;
            this.openFocus("post_input");
        },
        closeEdit() { //关闭编辑框
            this.pop.add_inputFlag = false;
            this.clearEdit();
        },
        hideEdit() {  //编辑框失去焦点
            if (this.pop.add_hover == true) {
                this.openFocus("post_input");
                return;
            }

            this.closeEdit();
        },
        clearEdit() {  //清空编辑框数据
            this.pop.add_editText = "";
        },
        uploadEdit() {  //上传新增职位
            if (this.pop.add_up_ing) {
                return;
            }
            this.pop.add_up_ing = true;

            let name = this.pop.add_editText;
            if (name.trim() == "") {
                this.errorTip("岗位不能为空");
                this.pop.add_up_ing = false;
                return;
            }

            this.addPosts.push({
                id:name,
                positionName:name,
            });

            this.pop.addNameId = name;
            this.closeEdit();
            this.pop.add_up_ing = false;
        },
        addClose() {  //数据清空
            this.pop.addNameId = "";
            this.pop.addType = "";
            this.pop.addNum = "";
            this.pop.addRequire = "";
            this.pop.addReason = "";
            // this.pop.add_loading = false;
            this.$form.clear("addPost");
        },
        confirm_add() {  //提交增岗申请
            let res = this.$form.check("addPost");
            console.log(`验证结果： ${res}`);
            if (!res) {
                return;
            }


            let name,id;
            if(isNaN(this.pop.addNameId - 0)){
                name = this.pop.addNameId;
            }else{
                id = this.pop.addNameId;
            }
 
            this.$func.loading(true);

            this.$http.post("api/manager/new_position_req", {
                position_id: id,
                position_name:name,
                req_type: this.pop.addType,
                trans_amount: parseInt(this.pop.addNum),
                position_description: this.pop.addRequire,
                remark: this.pop.addReason,
            }).then((res) => {
                if(res.status == 200){
                    this.successTip("增岗申请已提交成功");
                    this.pop.addFlag = false;
                }
                this.$func.loading(false);
            }).catch(error => {
                this.errorTip("申请提交失败");
                this.$func.loading(false);
            });

        },

        // 开罚单**********************
        ticketClose() {    //数据清空
            this.pop.ticketIds = [];
            this.pop.ticketType = "";
            // this.pop.ticketAmount = "";
            this.pop.ticketReason = "";
            this.$form.clear("ticket");
        },
        confirm_ticket() {   //提交罚单
            let res = this.$form.check("ticket");
            console.log(`验证结果： ${res}`);
            if (!res) {
                return;
            }

            
            let id = this.pop.ticketType;
            let userIds = this.pop.ticketIds;
            // let amount = this.pop.ticketAmount;
            let reason = this.pop.ticketReason;

            this.$func.loading(true);
            this.$http.post("api/manager/ticket_clerk", {
                ticket_category_id: id,
                sub_user_ids: userIds.join(","),
                // ticket_amount: amount,
                remark: reason,
            }).then(res => {
                if(res.status == 200){
                    this.pop.ticketFlag = false;
                    this.$func.getBuMembers(true); //重拿用户数据
                    //重置搜索项
                    this.ticket_search_type = "",
                    this.datePick_start = "",
                    this.datePick_end = "",
                    this.search();
                    this.successTip("罚单创建成功");
                }
                this.$func.loading(false);
            }).catch(err => {
                console.log(err);
                this.errorTip("罚单创建失败");
                this.$func.loading(false);
            })

        },

    },

}

</script>


<style lang="less" scoped>
@import "~src/assets/less/var.less";
@padd-top: 30px;
@padd-left: 30px;
@header-h: 150px;  //头部高度
@bu_color:#6471a4;  //边框背景色

.clear{  //清除浮动类
    zoom: 1;
    &:after{
        content:"";
        display: block;
        clear: both;
    }
}


// 最大包裹
.wrap {
    height: 100%;
    box-sizing: border-box;
    background: #fff;
    box-shadow: 0 0 4px 0 rgba(127, 127, 127, 0.50);
    padding-top: @padd-top;
}


/******** BU信息与人员*************/ 
.clerkWrap {
    height: 100%;
    padding: 0 @padd-left;
    box-sizing: border-box;

    .header {
        height: @header-h;
        border:1px solid @bu_color;
        border-radius:8px;
        overflow: hidden;

        @padd:25px;

        // 头部
        .top{
            height: 30px;
            line-height: 30px;
            position: relative;
            padding: 0 @padd;
            box-sizing: border-box;
            background:@bu_color;
            color:#fff;
            font-size: 12px;
            .bu-name{
                font-weight: 600;
                display: inline-block;
                max-width:300px;
            }   
            .bu-leader{
                display:inline-block;
                margin-left: 20px;
                vertical-align: top;
            }
            .time{
                position: absolute;
                right: @padd;
                top:0;
            }
        }

        .other{
            height:calc(~"100% - 30px");
            padding: 15px @padd;
            box-sizing: border-box;

            .text{
                height:calc(~"100% - 30px");
                font-size:15px;
                color:@bu_color;
            }

            .func{
                height:30px;
            }
        }
        
        // 提示信息
        .newInfo {
            line-height: 24px;
            font-size: 12px;
            color: #9b9b9b;
            letter-spacing: 1.33px;
            >.point {
                display: inline-block;
                background-color: #ff6b6b;
                width: 6px;
                height: 6px;
                border-radius: 100%;
                vertical-align: middle;
                margin-left: 16px;
                margin-right: 5px;
            }
        }

    }

    // 人员展示区
    .block {
        box-sizing: border-box;
        margin-top: 10px;
        height:calc(~"100% - @{header-h} - 10px");
        position: relative; // padding-bottom:@page-h;
        .box {
            margin-right: 45px;
            border:1px solid @bu_color;
            border-radius: 8px;
            box-sizing: border-box;
            &.leader{
                border-color:#00b993;
            }
        }

        // .block-item {
        //     padding-bottom: 10px;
        //     overflow: hidden;
        //     zoom: 1;
        // }

    }
}


/******罚单详情************/
.ticket-detail {
    height: 100%; // padding-bottom: @page-h;
    position: relative;
    box-sizing: border-box;
    .head {
        zoom: 1;
        margin-bottom: @padd-top;
        &:after {
            content: "";
            clear: both;
            display: block;
        }

        .func {
            float: left;
            margin-left: @padd-left;
            line-height: 30px;
        } // 关闭按钮 
        .el-icon-close {
            float: right;
            color: #808080;
            cursor: pointer;
            margin-top: 8px;
            margin-right: @padd-left;
        } // 选择框
        .top-choose {
            width: 120px;
        }
    }

    .list {
        height: calc(~"100% - 30px - 20px");
        padding-bottom: @page-h;
        position: relative;
        box-sizing: border-box;
        .list-detail {
            height: calc(~"100% - 41px");
            overflow: auto;
        }
    }

    .list-head {
        background: #f2f2f2;
        padding: 10px 0;
        padding-left: @padd-left;

        >div {
            position: relative;
            &:nth-of-type(n+2) {
                border-left: 1px solid #d3d3d3;
            } // &:nth-of-type(n+2):before{
            //     content:"";
            //     display: block;
            //     position: absolute;
            //     width: 1px;
            //     height: 100%;
            //     left: -10px;
            //     top: 50%;
            //     transform: translateY(-50%);
            //     background:#d3d3d3;
            // }
        }

        .angle-wrap {
            position: absolute;
            right: 17px;
            top: 50%;
            transform: translateY(-50%);
            .active {
                color: #f5a723;
            }
            i {
                display: block;
                color: #b2b2b2;
                font-size: 12px;
                transition: 0.3s;
                cursor: pointer;
            }
        }
    }

    .list-detail .item {
        padding: 10px 0;
        padding-left: @padd-left;
        border-bottom: 1px solid #efefef;
    }

    .list-head,
    .list-detail .item {
        &:after {
            content: "";
            clear: both;
            display: block;
        }
        @font: 14px; // 文字溢出隐藏
        .text-hide {
            display: inline-block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            max-width: 100%;
            position: relative;
            cursor: pointer;
            font-size: @font;
            &:hover {
                &+.more {
                    opacity: 1;
                }
            }
        }
        >div {
            float: left;
            box-sizing: border-box;
            font-size: @font;
            position: relative;
            .more {
                @w: 6px; //小三角
                position: absolute;
                font-size: @font;
                top: calc(~"100% + @{w}");
                left: 5px; // transform: translateX(-50%);
                background: #fff;
                box-shadow: 0 0 2px 1px #ccc;
                transition: 0.3s;
                opacity: 0;
                pointer-events: none;
                padding: 3px 5px;
                border-radius: 4px;
                z-index: 5;
                &:after {
                    content: "";
                    display: block;
                    position: absolute;
                    width: 0;
                    height: 0;
                    border-top: @w solid #fff;
                    border-right: @w solid #fff;
                    border-bottom: @w solid transparent;
                    border-left: @w solid transparent;
                    transform: rotate(-45deg);
                    box-shadow: 1px -1px 2px #ccc; // top:100%;
                    top: -@w;
                    left: 50%;
                    margin-left: -@w;
                    transform-origin: center center;
                }
            }
        }
        >div:nth-of-type(n+2) {
            padding-left: 10px;
        }
        >div:nth-of-type(1) {
            width: 10%
        }
        >div:nth-of-type(2) {
            width: 12%
        }
        >div:nth-of-type(3) {
            width: 18%;
        }
        >div:nth-of-type(4) {
            width: 12%
        }
        >div:nth-of-type(5) {
            width: 13%
        }
        >div:nth-of-type(6) {
            max-width: 35%;
        }
    }

    .cover {
        position: absolute;
        height: 100%;
        left: 10px;
        max-width: calc(~"100% - 10px");
        top: 0;
        opacity: 0.7;
    }
}

/******职员详情******************/

@main-c: #01b6ad; //主色调
.user-window {
    .user-tab-head {
        zoom: 1;
        padding-left: 20px;
        position:relative;
        &:after {
            content: "";
            display: block;
            clear: both;
        }

        .title {
            float: left;
            font-size: 14px;
            padding: 12px 10px;
            border-bottom: 1px solid transparent;
            transition: 0.3s;
            cursor: pointer;
            &+.title {
                margin-left: 80px;
            }
        }
        .active {
            color: @main-c;
            border-color: @main-c;
        }

        .func {
            position:absolute;
            top: 50%;
            transform: translateY(-50%);
            right:50px;
            // .top-choose {
            //     width: 120px;
            // }
            span{
                display: inline-block;
                margin-left: 20px;
            }
            button{
                margin-left: 20px;
            }
        }
    }

    .user-tab-wrap {
        // min-height: 300px;
        // max-height:486px;
        height:460px;

        >div{
            height: 100%;
            position: relative;
            box-sizing: border-box;
            padding-bottom: @page-h;
        }

        .user-list{
            height:100%;
        }
        // 头部
        .head{
            .clear();
            background: #f2f2f2;
            padding:10px 0;
            >div{
                float:left;
            }
        }
        //列表
        .user-wrap{
            height: calc(~"100% - 41px");
            .item{
                .clear();
                color:#808080;
                padding:10px 0;
                border-bottom: 1px solid #e6e6e6;
                font-size:12px;
                >div{
                    float:left;
                }
            }
        }


        // 结算列表
        .settle{
            text-align: center;
            .head,.user-wrap .item{
                >div:nth-of-type(1){width:17%;}
                >div:nth-of-type(2){width:17%;}
                >div:nth-of-type(3){width:17%;}
                >div:nth-of-type(4){width:17%;}
                >div:nth-of-type(5){width:17%;}
                >div:nth-of-type(6){width:15%;}
            }

            .item >div:last-child{
                color:#108ee9;
                cursor: pointer;
            }
        }

        // 罚单列表
        .ticket{
            .head,.user-wrap .item{
                >div:nth-of-type(1){
                    width:15%;
                    padding-left: 25px;
                    box-sizing: border-box;
                }
                >div:nth-of-type(2){width:15%;}
                >div:nth-of-type(3){width:15%;}
                >div:nth-of-type(4){width:15%;}
                >div:nth-of-type(5){width:37%;padding-right:3%;}
            }
        }

        // 职级列表
        .pmt{
            .head,.user-wrap .item{
                >div:nth-of-type(1){
                    width:20%;
                    padding-left: 25px;
                    box-sizing: border-box;
                }
                >div:nth-of-type(2){
                    width:20%;
                    text-align:center;
                }
                >div:nth-of-type(3){
                    width:20%;
                    text-align:center;
                }
                >div:nth-of-type(4){
                    max-width:40%;
                    padding-left: 30px;
                }
            }
        }

    }
}


/****弹窗定制**************/

@form-h: 30px; //项目高
.form-item {
    min-height: @form-h;
    line-height: @form-h;
}

// .el-input{
//     max-width:178px;
// }

// .el-input__inner {
//     height: 30px;
//     padding-top: 0;
//     padding-bottom: 0;
//     line-height: @form-h - 2px;
//     font-size: 12px;
// }

.form-item .item-wrap {
    // padding-bottom: 0;
    // margin-bottom: 30px;
}

// 增岗职位名称部分
.add-post {
    width: 30px;
    border-color: #d9d9d9;
    color: #bfcbd9;
    transition: .2s cubic-bezier(.645, .045, .355, 1);
    &:hover {
        border-color: #8391a5;
        color: #8391a5;
    }
}

// 输入职位
.add-input {
    position: absolute;
    width: 210px;
    top: calc(~"100% + 5px");
    z-index: 5;
    background: #fff;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    input {
        padding: 12px 8px;
        font-size: 12px;
    }
    .btns {
        text-align: right; // line-height: 15px;
        padding: 6px 0;
        border-top: 1px solid #d9d9d9;
        font-size: 0;
        @m: 10px;

        i {
            cursor: pointer;
            display: inline-block;
            padding: 3px 0;
            margin: 0 @m;
            position: relative;
            font-size: 12px;
            transform: scale(0.8);
            vertical-align: middle;
            width: 12px;
            &:nth-of-type(1):after {
                content: "";
                display: block;
                width: 1px;
                height: 100%;
                background: #999;
                position: absolute;
                right: 0 - @m - 6px;
                top: 0; // border-right: 1px solid #999;
            }
        }
    }
    .el-icon-close {
        transition: 0.2s;
        &:hover {
            color: #ff6b6b;
        }
    }
    .el-icon-check {
        transition: 0.2s;
        &:hover {
            color: #108ee9;
        }
    }
    .el-icon-loading {
        color: #108ee9;
    }
}

// 选项
.el-icon-delete {
    display: none;
    transition: 0.2s;
    &:hover {
        color: #ff6b6b;
    }
}

.hover,
.selected {
    .el-icon-delete {
        display: inline-block;
    }
}

@place-color: #bfcbd9;
::-webkit-input-placeholder {
    color: @place-color;
}

::-moz-placeholder {
    color: @place-color;
}

::-moz-placeholder {
    color: @place-color;
}

::-ms-input-placeholder {
    color: @place-color;
}

</style>




// WEBPACK FOOTER //
// page-personManage.vue?2661e80e